import { ref, set } from 'firebase/database';
import { database } from '../firebaseConfig';

// Keeps every marketing link for a transaction in one place (transactions/{id}/marketingLinks),
// so anyone can find the feature cards, brochures, mailers and feature and upgrade list later.
export const saveMarketingLink = async (transactionId, key, label, url) => {
  if (!transactionId || !key || !url) return;
  await set(ref(database, `transactions/${transactionId}/marketingLinks/${key}`), {
    label,
    url,
    savedAt: new Date().toISOString(),
  });
};
